import { Grid, Tooltip, Typography, withStyles, Theme } from '@material-ui/core';
import { equals } from 'ramda';
import { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { InformPromptDialog } from '~components/Dialogs';
import { PageLoader } from '~components/Page';
import { DataPlaceholder } from '~ui-kit/index';
import { InformationBadge } from '~ui-kit/InformationBadge/InformationBadge';

import { ImageInTooltip } from './ImageInTooltip';
import { getUnitImagesQuery } from './UnitsDialog.config';

import { Alarm } from '~models';
import { boundActions, selectors } from '~store';

type UnitImagesListDialogProps = {
  open: boolean;
  alarm: Alarm;
  onClose: () => void;
};

const ImageTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    border: 0,
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
}))(Tooltip);

const MouseBadge = withStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    margin: theme.spacing(-1, 0, 2, 0),
  },
}))(InformationBadge);

export const UnitImagesListDialog = ({ open = false, alarm, onClose }: UnitImagesListDialogProps) => {
  const images = useSelector(selectors.alarms.getUnitImages, equals);
  const { images: isLoading } = useSelector(selectors.alarms.getAlarmsLoaders, equals);
  const query = getUnitImagesQuery(alarm);

  useEffect(() => {
    if (open && query) {
      boundActions.alarms.fetchUnitImagesInit({ query });
    }

    return () => {
      boundActions.alarms.resetUnitImages();
    };
  }, [open]);

  return (
    <InformPromptDialog
      open={open}
      title="Associated Images"
      onConfirm={onClose}
      buttonName="Close"
    >
      {isLoading ? <PageLoader /> :
        images?.length ?
          (<Fragment>
            <MouseBadge>
                Mouse over a name to view image
            </MouseBadge>
            <Grid container spacing={2}>
              {images.map(image =>
                <Grid item xs={12} key={image.id}>
                  <Typography color="primary">
                    <ImageTooltip title={<ImageInTooltip id={image.id as number} />}>
                      <Grid style={{ cursor: 'pointer' }}>{`Name: ${image.assetName}`}</Grid>
                    </ImageTooltip>
                  </Typography>
                  <Typography>
                    {`Notes: ${image.notes}`}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Fragment>) :
          <DataPlaceholder title="No Images" />
      }
    </InformPromptDialog>
  );
};
